import axios from 'axios';
import { AuthenticationClient } from '../../authentication/client';
import { DirectLinkMeta, PageView } from '../types';
import { buildSavedViewLink } from './utils';
import constants from '../constants';

const { SHARE_VIEW_API_URL } = constants;

type PageViewResponse<T extends object> = Omit<PageView<T>, 'created_at'> & { created_at: string };

export const mapResponseToPageView = <T>(pageViewResponse: T & { created_at: string }): T & { created_at: Date } => ({
  ...pageViewResponse,
  created_at: pageViewResponse.created_at ? new Date(pageViewResponse.created_at) : undefined,
});

export const getPageView = async <TViewState extends object>(key: string): Promise<PageView<TViewState>> => {
  const token = await AuthenticationClient.getInstance().getAccessToken();
  const response = await axios.get<PageViewResponse<TViewState>>(`${SHARE_VIEW_API_URL}/v1/page-views/${key}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const pageViewResponse = response.data;
  if (!pageViewResponse) {
    throw new Error('Received no data from backend');
  }

  const pageView = mapResponseToPageView(pageViewResponse);
  return pageView;
};

export const getDirectViewLink = async (key: string): Promise<string | null> => {
  const pageView = await getPageView<object>(key);
  const meta = pageView.meta as DirectLinkMeta;
  const { pathname, search } = meta;
  if (!pathname && !search) {
    return null;
  }
  const link = buildSavedViewLink(key, { pathname, search });
  return link;
};
